import React from 'react';
import styled from 'styled-components';
import { Margin } from './layout-components';
import CustomizedChip from './Chip';

const InlineMargin = styled(Margin)`
  display: inline-block;
`;
const ChipsList = ({ chips = [] }) =>
  chips.map((chip, idx) => (
    <InlineMargin r='small' b='small' key={`c-${idx}`}>
      <CustomizedChip {...chip} />
    </InlineMargin>
  ));

export default ChipsList;
